import { api } from '@/core/api/';

const baseApiURL = 'api/budget';

export const getAllAcademicYearsForBudget = () =>
  api.get(`${baseApiURL}/initfilters`);

export const getAcademicYearsWithoutBudget = () =>
  api.get(`${baseApiURL}/add/years`);

export const getBudgetData = (academicYearId) =>
  api.get(`${baseApiURL}/budgetdata/${academicYearId}`);

export const addBudget = (payload) => api.post(`${baseApiURL}`, payload);

export const adjustBudget = (payload) =>
  api.post(`${baseApiURL}/adjust`, payload);
